import { render, staticRenderFns } from "./ApplicationNote.vue?vue&type=template&id=2650b824&scoped=true&lang=pug&"
import script from "./ApplicationNote.vue?vue&type=script&lang=js&"
export * from "./ApplicationNote.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationNote.vue?vue&type=style&index=0&id=2650b824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650b824",
  null
  
)

/* custom blocks */
import block0 from "./ApplicationNote.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports